var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConventions2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02---2021-UI-Update---Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Flexi-fesk-attivo",
    transform: "translate(-286, -456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(286, 456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5,0 C41.1355459,-2.68850616e-15 53,11.8644541 53,26.5 C53,41.1355459 41.1355459,53 26.5,53 C11.8644541,53 8.9616872e-16,41.1355459 0,26.5 C-1.79233744e-15,11.8644541 11.8644541,1.79233744e-15 26.5,0 Z",
    id: "Background-Copy-3",
    fill: "#3B7FED",
    opacity: 0.167364211
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-/-FAB-/-gym-Copy",
    transform: "translate(13.0909, 13.0909)",
    fill: "#3B7FED",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sell_FILL0_wght400_GRAD0_opsz24-(2)",
    transform: "translate(0, -0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8846676,26.8493894 C16.3310719,27.4029851 15.6390773,27.6797829 14.9470828,27.6797829 C14.1166893,27.6797829 13.5630936,27.4029851 13.009498,26.8493894 L0.830393487,14.6702849 C0.553595658,14.3934871 0.415196744,14.1166893 0.276797829,13.8398915 C0.138398915,13.4246947 0,13.009498 0,12.5943012 L0,2.76797829 C0,2.07598372 0.276797829,1.38398915 0.830393487,0.830393487 C1.38398915,0.276797829 2.07598372,0 2.76797829,0 L12.7327001,0 C13.1478969,0 13.4246947,0.138398915 13.8398915,0.276797829 C14.1166893,0.415196744 14.531886,0.691994573 14.8086839,0.830393487 L26.9877883,13.009498 C27.541384,13.5630936 27.8181818,14.2550882 27.8181818,14.9470828 C27.8181818,15.6390773 27.541384,16.3310719 26.9877883,16.8846676 L16.8846676,26.8493894 Z M14.9470828,24.9118046 L24.9118046,14.9470828 L12.7327001,2.76797829 L2.76797829,2.76797829 L2.76797829,12.7327001 L14.9470828,24.9118046 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91994573,10.3799186 C6.91994573,8.85753053 7.88873813,7.88873813 9.27272727,7.88873813 C10.6567164,7.88873813 11.6255088,8.85753053 11.6255088,10.3799186 C11.6255088,11.9023066 10.6567164,12.8710991 9.27272727,12.8710991 C7.88873813,12.8710991 6.91994573,12.0407056 6.91994573,10.3799186 Z M14.531886,8.02713704 L16.6078697,8.02713704 L10.5183175,16.8846676 L8.44233379,16.8846676 L14.531886,8.02713704 Z M9.96472185,10.3799186 C9.96472185,9.5495251 9.68792402,9.27272727 9.41112619,9.27272727 C9.13432836,9.27272727 8.71913161,9.5495251 8.71913161,10.3799186 C8.71913161,11.2103121 8.99592944,11.4871099 9.27272727,11.4871099 C9.5495251,11.4871099 9.96472185,11.2103121 9.96472185,10.3799186 Z M13.4246947,14.531886 C13.4246947,13.009498 14.3934871,12.0407056 15.7774763,12.0407056 C17.1614654,12.0407056 18.1302578,13.009498 18.1302578,14.531886 C18.1302578,16.0542741 17.1614654,17.0230665 15.7774763,17.0230665 C14.531886,17.0230665 13.4246947,16.192673 13.4246947,14.531886 Z M16.4694708,14.531886 C16.4694708,13.7014925 16.192673,13.4246947 15.9158752,13.4246947 C15.6390773,13.4246947 15.3622795,13.7014925 15.3622795,14.531886 C15.3622795,15.3622795 15.6390773,15.6390773 15.9158752,15.6390773 C16.192673,15.6390773 16.4694708,15.3622795 16.4694708,14.531886 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#3B7FED",
    cx: 43,
    cy: 43,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-/-small-/-add-copy-5",
    transform: "translate(37.3995, 38)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6005051,0 L10.6005051,9 L8.60050506,9 L8.6,3.506 L1.41421356,10.6923882 L3.90798505e-14,9.27817459 L7.277,2 L1.60050506,2 L1.60050506,0 L10.6005051,0 Z",
    id: "Combined-Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConventions2);
export default __webpack_public_path__ + "static/media/conventions2.3eef43335def6c644387c57f75973ac5.svg";
export { ForwardRef as ReactComponent };